export default __webpack_public_path__ + "static/media/upload.f1880ac4.svg";